import { escapeAttr } from "@emkit/builder-core";
export const VIDEO_DEFAULTS = {
    src: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    source: "youtube",
    aspectRatio: "16/9",
    autoplay: false,
    muted: true,
    loop: false,
    controls: true,
};
function extractYouTubeId(url) {
    const m = url.match(/(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/);
    return m?.[1] ?? null;
}
function extractVimeoId(url) {
    const m = url.match(/vimeo\.com\/(\d+)/);
    return m?.[1] ?? null;
}
function errorBox(msg) {
    return `<div class="emk-video-error" style="padding:16px;background:#fef2f2;color:#991b1b;border:1px solid #fecaca;border-radius:8px;font-size:13px">${msg}</div>`;
}
export const videoWidget = {
    type: "video",
    defaultProps: VIDEO_DEFAULTS,
    renderHtml(props) {
        const radius = props.radius ? `border-radius:${props.radius}px;` : "";
        const wrap = `position:relative;width:100%;aspect-ratio:${props.aspectRatio};overflow:hidden;${radius}`;
        if (props.source === "youtube") {
            const id = extractYouTubeId(props.src);
            if (!id)
                return errorBox("Invalid YouTube URL — paste the full watch URL.");
            const p = new URLSearchParams();
            if (props.autoplay)
                p.set("autoplay", "1");
            if (props.muted)
                p.set("mute", "1");
            if (props.loop) {
                p.set("loop", "1");
                p.set("playlist", id);
            }
            if (!props.controls)
                p.set("controls", "0");
            const src = `https://www.youtube.com/embed/${id}?${p.toString()}`;
            return `<div class="emk-video" style="${wrap}"><iframe src="${escapeAttr(src)}" style="position:absolute;inset:0;width:100%;height:100%;border:0" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe></div>`;
        }
        if (props.source === "vimeo") {
            const id = extractVimeoId(props.src);
            if (!id)
                return errorBox("Invalid Vimeo URL — paste the full video URL.");
            const p = new URLSearchParams();
            if (props.autoplay)
                p.set("autoplay", "1");
            if (props.muted)
                p.set("muted", "1");
            if (props.loop)
                p.set("loop", "1");
            const src = `https://player.vimeo.com/video/${id}?${p.toString()}`;
            return `<div class="emk-video" style="${wrap}"><iframe src="${escapeAttr(src)}" style="position:absolute;inset:0;width:100%;height:100%;border:0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen loading="lazy"></iframe></div>`;
        }
        // Direct URL (mp4/webm)
        const attrs = [
            `src="${escapeAttr(props.src)}"`,
            props.controls ? "controls" : "",
            props.autoplay ? "autoplay" : "",
            props.muted ? "muted" : "",
            props.loop ? "loop" : "",
            "playsinline",
            `preload="metadata"`,
        ]
            .filter(Boolean)
            .join(" ");
        return `<div class="emk-video" style="${wrap}"><video ${attrs} style="position:absolute;inset:0;width:100%;height:100%;object-fit:contain;background:#000"></video></div>`;
    },
};
//# sourceMappingURL=video.js.map